<template>
    <v-container class="pa-0" fluid v-if="!loading">
        <div v-if="!results&&(list==='search'||list==='searchAll')">
            <v-row class="pt-6 px-6">
                <v-col cols="2">
                    <v-text-field v-model="pten_code" label="Lead ID" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="pten_naam" label="Lead (last)name" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="pten_email" label="Lead email" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
            </v-row>
            <v-row class="px-6">
                <!-- <v-col cols="2" class="mt-1"> -->
                <v-col cols="2">
                    <selector ref="stat1" :options="statCodes" option_field="statCodesSelected" label="Status" :visibleChips=1 :isClearable="true" @updateData="updateData2" />
                    <!-- <v-select v-model="statCodesSelected" :items="statCodes" item-value="statCode" item-text="description" label="Status" multiple chips clearable dense></v-select> -->
                </v-col>
                <v-col cols="2">
                    <selector ref="bron1" :options="bronCodes" option_field="bronCodesSelected" label="Source" :visibleChips=1 @updateData="updateData2" />
                    <!-- <v-select v-model="bronCodesSelected" :items="bronCodes" item-value="bronCode" item-text="description" label="Source" multiple chips clearable dense></v-select> -->
                </v-col>
                <!-- <v-col cols="2" class="mt-1"> -->
                <v-col cols="2">
                    <selector ref="ambassador1" :options="ambassadorCodes" option_field="ambassadorCodesSelected" label="Ambassador" :visibleChips=1 @updateData="updateData2" />
                    <!-- <v-select v-model="ambassadorCodesSelected" :items="ambassadorCodes" item-value="ambassadorCode" item-text="description" label="Ambassador" multiple chips clearable dense></v-select> -->
                </v-col>
            </v-row>
            <v-row class="px-6">
                <v-col cols="2">
                    <v-text-field v-model="pten_acco_adres" label="Accommodation address" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="pten_acco_postcode" label="Accommodation postcode" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-text-field v-model="pten_acco_city" label="Accommodation city" @keyup.enter="getPtens" dense></v-text-field>
                </v-col>
            </v-row>
            <v-row class="px-6">
                <v-col cols="3">
                    <v-select v-model="provCodesSelected" :items="provCodes" item-value="provCode" item-text="description" label="Accommodation province" multiple chips clearable dense></v-select>
                </v-col>
                <v-col cols="3">
                    <v-select v-model="landCodesSelected" :items="landCodes" item-value="landCode" item-text="description" label="Accommodation country" multiple chips clearable dense></v-select>
                </v-col>
            </v-row>
            <v-row class="px-6">
                <v-col cols="6" v-if="local_agent===''||list==='searchAll'">
                    <v-select v-model="gebrCodesSelected" :items="gebrCodes" item-value="gebrCode"  item-text="gebrNaam" label="Agent" multiple chips dense></v-select>
                </v-col>
                <v-col cols="6" v-else></v-col>
                <v-col cols="1">
                    <v-btn class="primary" :disabled="disableSearch" @click="getPtens">Search</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-card class="pa-2" >
                <v-card-title class="pt-0 pb-0 justify-center">Leads</v-card-title>
                <v-divider></v-divider>
                <v-row class="pa-4" v-if="list==='search'||list==='searchAll'">
                    <v-btn class="primary" small @click="showParameters" >Back to parameters</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" small @click="buildReport" :disabled="disableExport" color="success">
                        <v-icon small class="pr-2">mdi-microsoft-excel</v-icon>
                        <span class="pr-1">Export</span>
                    </v-btn>
                </v-row>
                <v-divider v-if="list==='search'||list==='searchAll'"></v-divider>
                <v-row>
                    <v-col cols="6"><v-text-field v-model="search" label="Search leads" single-line hide-details prepend-icon="mdi-magnify"></v-text-field></v-col>
                    <v-col cols="6"><selector ref="stat2" :options="statCodes" option_field="statCodesSelected" label="Filter on status" :visibleChips=2 :isClearable="true" @updateData="updateData" v-if="list!=='deduplicate'&&list!=='assign'&&list!=='phonelist'" /></v-col>
                </v-row>
                <v-data-table
                    :items="items"
                    :items-per-page="10"
                    :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                    :headers="headers"
                    :search="search">
                    <template v-slot:item="props">
                        <tr v-if="list==='search'||list==='searchAll'">
                            <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td>
                            <!-- <td><div><router-link :to="'onPten/' + props.item.pten_encrid" custom>{{ props.item.pten_code }}</router-link></div></td> -->
                            <td><btn_component type="avatar_text" :tooltip="props.item.pten_hist_short" text="H" size="small" data="" @actionClick="viewHistoryDialog(props.item.pten_code, props.item.pten_hist_long)"/></td>
                            <!-- <td>{{ props.item.pten_stat }}</td> -->
                            <td>{{ props.item.pten_stat }}<br/>{{ props.item.pten_bron }}</td>
                            <td v-if="props.item.pten_ambassador_encrid>''" @click="$router.open('/eign/onEign/' + props.item.pten_ambassador_encrid)"><a>{{ props.item.pten_ambassador }}</a></td>
                            <td v-else></td>
                            <td>{{ props.item.pten_voornaam }}</td>
                            <td>{{ props.item.pten_naam }}</td>
                            <td>{{ props.item.pten_bedrijfsnaam }}</td>
                            <td>{{ props.item.pten_mail }}</td>
                            <td>{{ props.item.pten_tel1_vcs }}</td>
                            <td>{{ props.item.pten_gebr_code }}</td>
                            <td>{{ props.item.pten_acco_type }}</td>
                            <td>{{ props.item.pten_acco_land }}</td>
                            <td>{{ props.item.pten_acco_prov }}</td>
                            <td>{{ props.item.pten_acco_city }}</td>
                        </tr>
                        <tr v-if="list==='deduplicate'">
                            <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td>
                            <!-- <td><div><router-link :to="'onPten/' + props.item.pten_encrid" custom>{{ props.item.pten_code }}</router-link></div></td> -->
                            <td>{{ props.item.pten_stat }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            x-small
                                            text icon
                                            v-bind="attrs"
                                            v-on="on"
                                            v-on:click="setDuplicate(props.item)"
                                            class="button-margin-lr gridbutton">
                                            <v-icon small color="red">mdi-account-remove-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Mark as duplicate</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            x-small
                                            text icon
                                            v-bind="attrs"
                                            v-on="on"
                                            v-on:click="setToAssign(props.item)"
                                            class="button-margin-lr gridbutton">
                                            <v-icon small color="green">mdi-account-check-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Mark as not a duplicate</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            x-small
                                            text icon
                                            v-bind="attrs"
                                            v-on="on"
                                            v-on:click="assignPtenLead(props.item)"
                                            class="button-margin-lr gridbutton">
                                            <v-icon small>mdi-account-plus-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Assign lead <br> (not a duplicate)</span>
                                </v-tooltip>
                            </td>
                            <td>{{ props.item.pten_bron }}</td>
                            <td v-if="props.item.pten_ambassador_encrid>''" @click="$router.open('/eign/onEign/' + props.item.pten_ambassador_encrid)"><a>{{ props.item.pten_ambassador }}</a></td>
                            <td v-else></td>
                            <td>{{ props.item.pten_voornaam }}</td>
                            <td>{{ props.item.pten_naam }}</td>
                            <td>{{ props.item.pten_bedrijfsnaam }}</td>
                            <td>{{ props.item.pten_mail }}</td>
                            <td>{{ props.item.pten_tel1_vcs }}</td>
                            <td>{{ props.item.pten_gebr_code }}</td>
                            <td>{{ props.item.pten_acco_type }}</td>
                            <td>{{ props.item.pten_acco_land }}</td>
                            <td>{{ props.item.pten_acco_prov }}</td>
                            <td>{{ props.item.pten_acco_city }}</td>
                        </tr>
                        <tr v-if="list==='assign'||list==='phonelist'">
                            <td @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td>
                            <!-- <td><div><router-link :to="'onPten/' + props.item.pten_encrid" custom>{{ props.item.pten_code }}</router-link></div></td> -->
                            <td>{{ props.item.pten_stat }}</td>
                            <td>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            x-small
                                            text icon
                                            v-bind="attrs"
                                            v-on="on"
                                            v-on:click="assignPtenLead(props.item)"
                                            class="button-margin-lr gridbutton">
                                            <v-icon small>mdi-account-plus-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Assign lead</span>
                                </v-tooltip>
                            </td>
                            <td>{{ props.item.pten_bron }}</td>
                            <td v-if="props.item.pten_ambassador_encrid>''" @click="$router.open('/eign/onEign/' + props.item.pten_ambassador_encrid)"><a>{{ props.item.pten_ambassador }}</a></td>
                            <td v-else></td>
                            <td>{{ props.item.pten_voornaam }}</td>
                            <td>{{ props.item.pten_naam }}</td>
                            <td>{{ props.item.pten_bedrijfsnaam }}</td>
                            <td>{{ props.item.pten_mail }}</td>
                            <td>{{ props.item.pten_tel1_vcs }}</td>
                            <td>{{ props.item.pten_gebr_code }}</td>
                            <td>{{ props.item.pten_acco_type }}</td>
                            <td>{{ props.item.pten_acco_land }}</td>
                            <td>{{ props.item.pten_acco_prov }}</td>
                            <td>{{ props.item.pten_acco_city }}</td>
                        </tr>
                        <tr v-if="list==='agent'">
                            <td class="align-text-top" @click="$router.open('/pten/onPten/' + props.item.pten_encrid)"><a>{{ props.item.pten_code }}</a></td>
                            <!-- <td><div><router-link :to="'onPten/' + props.item.pten_encrid" custom>{{ props.item.pten_code }}</router-link></div></td> -->
                            <td class="align-text-top"><btn_component type="avatar_text" :tooltip="props.item.pten_hist_short" text="H" size="small" data="" @actionClick="viewHistoryDialog(props.item.pten_code, props.item.pten_hist_long)"/></td>
                            <td class="align-text-top">{{ props.item.gebr_code }}</td>
                            <td class="align-text-top">{{ props.item.pten_stat }}<br/>{{ props.item.pten_bron }}</td>
                            <!-- <td>{{ props.item.pten_voornaam }} {{ props.item.pten_naam }}<br>{{ props.item.pten_bedrijfsnaam }}</td> -->
                            <td class="align-text-top">{{ props.item.pten_naam2 }}</td>
                            <td class="align-text-top">{{ props.item.pten_mail }}<br>{{ props.item.pten_tel1_vcs }}</td>
                            <td class="align-text-top">{{ props.item.pten_acco_type }}</td>
                            <td class="align-text-top">{{ props.item.pten_acco_city }}<br>{{ props.item.pten_acco_prov }}<br>{{ props.item.pten_acco_land }}</td>
                            <td class="align-text-top">
                                <div v-for="action in props.item.actions" :key="action.ptac_nr">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on" class="d-inline-block text-truncate">
                                                <span class="px-2 error" v-if="action.ptac_stat==='Overdue'">{{ action.ptac_stat }}: {{ action.pten_code }}.{{ action.ptac_nr }} - {{ action.patp_oms }}</span>
                                                <span class="px-2" v-else>{{ action.ptac_stat }}: {{ action.pten_code }}.{{ action.ptac_nr }} - {{ action.patp_oms }}</span>
                                            </span>
                                        </template>
                                        <span >{{ action.ptac_oms }}</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <assignLead ref="assignLead" @actionClick="actionClick"/>
        <setDuplicateLead ref="setDuplicateLead" @actionClick="actionClick"/>
        <setAssignLead ref="setAssignLead" @actionClick="actionClick"/>
        <showProgress ref="showProgress"/>
        <viewHistory ref="viewHistory"/>
    </v-container>
    <v-container class="pa-5 px-1" fluid v-else>
        <cardWait/>
    </v-container>
</template>

<script>
    import selector from "@/components/ui/selectors/selector.vue";
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import showProgress from "@/components/showProgress.vue";
    import assignLead from '@/components/pten/assignLead.vue';
    import setDuplicateLead from '@/components/pten/setDuplicateLead.vue';
    import setAssignLead from '@/components/pten/setAssignLead.vue';
    import viewHistory from "@/components/pten/viewHistory.vue";
    import cardWait from "@/components/pten/cardWait.vue";

    export default {
        props: {
            list: {
                type: String,
                required: false,
                default: "search",
            },
            agent: {
                type: String,
                required: false,
                default: "",
            },
        },
        components: {
            selector,
            btn_component,
            showProgress,
            assignLead,
            setDuplicateLead,
            setAssignLead,
            viewHistory,
            cardWait,
        },
        computed: {
            headers() {
                switch(this.list) {
                    case "search":
                    case "searchAll":
                        return [
                                {text: 'Id', value: 'pten_code', tdClass: 'align-text-top' },
                                {text: 'History', value: 'pten_hist_short'},
                                // {text: 'Status', value: 'pten_stat'},
                                {text: 'Status / Source', value: 'pten_bron'},
                                {text: 'Ambassador', value: 'pten_ambassador', tdClass: 'align-text-top' },
                                {text: 'Name', value: 'pten_voornaam'},
                                {text: 'Surname', value: 'pten_naam'},
                                {text: 'Company name', value: 'pten_bedrijfsnaam'},
                                {text: 'E-mail', value: 'pten_mail'},
                                {text: 'Telephone', value: 'pten_tel1_vcs'},
                                {text: 'Agent', value: 'pten_gebr_code'},
                                {text: 'Acco type', value: 'pten_acco_type'},
                                {text: 'Acco country', value: 'pten_acco_land'},
                                {text: 'Acco province', value: 'pten_acco_prov'},
                                {text: 'Acco city', value: 'pten_acco_city'},
                            ]
                    case "deduplicate":
                        return [
                            {text: 'Id', value: 'pten_code', tdClass: 'align-text-top' },
                            {text: 'Status', value: 'pten_stat'},
                            {text: 'Duplicate', value: ''},
                            {text: 'Source', value: 'pten_bron'},
                            {text: 'Ambassador', value: 'pten_ambassador', tdClass: 'align-text-top' },
                            {text: 'Name', value: 'pten_voornaam'},
                            {text: 'Surname', value: 'pten_naam'},
                            {text: 'Company name', value: 'pten_bedrijfsnaam'},
                            {text: 'E-mail', value: 'pten_mail'},
                            {text: 'Telephone', value: 'pten_tel1_vcs'},
                            {text: 'Agent', value: 'pten_gebr_code'},
                            {text: 'Acco type', value: 'pten_acco_type'},
                            {text: 'Acco country', value: 'pten_acco_land'},
                            {text: 'Acco province', value: 'pten_acco_prov'},
                            {text: 'Acco city', value: 'pten_acco_city'},
                        ]
                    case "assign":
                        return [
                            {text: 'Id', value: 'pten_code', tdClass: 'align-text-top' },
                            {text: 'Status', value: 'pten_stat'},
                            {text: 'Assign', value: 'pten_assign'},
                            {text: 'Source', value: 'pten_bron'},
                            {text: 'Ambassador', value: 'pten_ambassador', tdClass: 'align-text-top' },
                            {text: 'Name', value: 'pten_voornaam'},
                            {text: 'Surname', value: 'pten_naam'},
                            {text: 'Company name', value: 'pten_bedrijfsnaam'},
                            {text: 'E-mail', value: 'pten_mail'},
                            {text: 'Telephone', value: 'pten_tel1_vcs'},
                            {text: 'Agent', value: 'pten_gebr_code'},
                            {text: 'Acco type', value: 'pten_acco_type'},
                            {text: 'Acco country', value: 'pten_acco_land'},
                            {text: 'Acco province', value: 'pten_acco_prov'},
                            {text: 'Acco city', value: 'pten_acco_city'},
                        ]
                    case "phonelist":
                        return [
                            {text: 'Id', value: 'pten_code', tdClass: 'align-text-top' },
                            {text: 'Status', value: 'pten_stat'},
                            {text: 'Assign', value: 'pten_assign'},
                            {text: 'Source', value: 'pten_bron'},
                            {text: 'Name', value: 'pten_voornaam'},
                            {text: 'Surname', value: 'pten_naam'},
                            {text: 'Company name', value: 'pten_bedrijfsnaam'},
                            {text: 'E-mail', value: 'pten_mail'},
                            {text: 'Telephone', value: 'pten_tel1_vcs'},
                            {text: 'Agent', value: 'pten_gebr_code'},
                            {text: 'Acco type', value: 'pten_acco_type'},
                            {text: 'Acco country', value: 'pten_acco_land'},
                            {text: 'Acco province', value: 'pten_acco_prov'},
                            {text: 'Acco city', value: 'pten_acco_city'},
                        ]
                    case "agent":
                        return [
                            {text: 'Id', value: 'pten_code', tdClass: 'align-text-top'},
                            {text: 'History', value: 'pten_hist_short'},
                            {text: 'Agent', value: 'gebr_code'},
                            {text: 'Status/source', value: 'pten_stat', tdClass: 'align-text-top'},
                            {text: 'Name/company', value: 'pten_naam2', tdClass: 'align-text-top'},
                            {text: 'E-mail/Telephone', value: 'pten_mail', tdClass: 'align-text-top'},
                            {text: 'Acco type', value: 'pten_acco_type', tdClass: 'align-text-top'},
                            {text: 'Acco Location', value: 'pten_location', tdClass: 'align-text-top'},
                            {text: 'Actions', value: '', tdClass: 'align-text-top'},
                        ]
                    default:
                        return [
                            {text: 'Id', value: 'pten_code', tdClass: 'align-text-top' },
                            {text: 'History', value: 'pten_hist_short'},
                            // {text: 'Status', value: 'pten_stat'},
                            {text: 'Source', value: 'pten_bron'},
                            {text: 'Ambassador', value: 'pten_ambassador', tdClass: 'align-text-top' },
                            {text: 'Name', value: 'pten_voornaam'},
                            {text: 'Surname', value: 'pten_naam'},
                            {text: 'Company name', value: 'pten_bedrijfsnaam'},
                            {text: 'E-mail', value: 'pten_mail'},
                            {text: 'Telephone', value: 'pten_tel1_vcs'},
                            {text: 'Agent', value: 'pten_gebr_code'},
                            {text: 'Acco type', value: 'pten_acco_type'},
                            {text: 'Acco country', value: 'pten_acco_land'},
                            {text: 'Acco province', value: 'pten_acco_prov'},
                            {text: 'Acco city', value: 'pten_acco_city'},
                        ]
                }
            },
        },
        watch: {
            agent(value) {
                if (value !== this.last) {
                    this.local_agent = value;
                }
            },
            local_agent(value) {
                if (value !== this.last && this.list !== "search" && this.list !== 'searchAll') {
                    this.last = value;
                    this.getPtens();
                }
            },
        },
        data() {
            return {
                results: false,
                loading: false,
                disableSearch: true,
                disableExport: false,
                last: "",
                local_agent: "",
                statCodesSelected: [],
                statCodes: [],
                bronCodesSelected: [],
                bronCodes: [],
                ambassadorCodesSelected: [],
                ambassadorCodes: [],
                gebrCodesSelected: [],
                gebrCodes: [],
                landCodesSelected: [],
                landCodes: [],
                provCodesSelected: [],
                provCodes: [],
                agents: [],
                items: [],
                pten_code: "",
                pten_naam: "",
                pten_email: "",
                pten_acco_adres: "",
                pten_acco_postcode: "",
                pten_acco_city: "",
                param: {},
                search: "",
            }
        },
        mounted() {
            this.local_agent = this.agent;
            if (this.list==="search" || this.list==="searchAll") {
                this.$axios.post("ares/json/ares/pten/getSearchPtenParam.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSearchPtenParam"
                    },
                    getSearchPtenParam: {
                        list: this.list,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.makeSelectNew(res.data.getSearchPtenParam.statKeuzes, "statCodes", "statCodesSelected");
                        this.makeSelectNew(res.data.getSearchPtenParam.bronKeuzes, "bronCodes", "bronCodesSelected");
                        this.makeSelectNew(res.data.getSearchPtenParam.ambassadorKeuzes, "ambassadorCodes", "ambassadorCodesSelected");
                        // this.makeSelect(res.data.getSearchPtenParam.bronKeuzes, "bronCodes", "bronCodesSelected", "bronCode", "bronSelected");
                        this.makeSelect(res.data.getSearchPtenParam.gebrKeuzes, "gebrCodes", "gebrCodesSelected", "gebrCode", "gebrSelected");
                        this.makeSelect(res.data.getSearchPtenParam.landKeuzes, "landCodes", "landCodesSelected", "landCode", "landSelected");
                        this.makeSelect(res.data.getSearchPtenParam.provKeuzes, "provCodes", "provCodesSelected", "provCode", "provSelected");

                        this.local_agent = res.data.getSearchPtenParam.agent;
                        this.$emit("setTitle", res.data.getSearchPtenParam.agentName);

                        //console.log(this.statCodes);
                        this.$refs.stat1.updateSelector(this.statCodes);
                        this.$refs.bron1.updateSelector(this.bronCodes);
                        this.$refs.ambassador1.updateSelector(this.ambassadorCodes);
                        //console.log(this.statCodesSelected);
                        this.disableSearch = false;
                    }
                });
            } else {
                this.getPtens();
            }

        },
        methods: {
            makeSelect(options, codes, selectedCodes, codeField, codeSelected) {
                this[codes] = [];
                this[selectedCodes] = [];

                options.forEach((option) => {
                    // New naming
                    option.isSelected = option[codeSelected];
                    this[codes].push(option);
                    if (option[codeSelected]) {
                        this[selectedCodes].push(option[codeField]);
                    }
                });
            },
            makeSelectNew(options, codes, selectedCodes) {
                this[codes] = options;
                this[selectedCodes] = [];

                options.forEach((option) => {
                    if (option["isSelected"]) {
                        this[selectedCodes].push(option);
                    }
                });
                //this.statCodes = options;
            },
            getSelected(options) {
                let selected = [];
                options.forEach((option) => {
                    selected.push(option.Option);
                });
                return selected;
            },
            getPtens() {
                this.loading = true;
                this.$axios.post("ares/json/ares/pten/searchPten.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchPten"
                    },
                    searchPten: {
                        list: this.list,
                        agent: this.local_agent === null ? "" : this.local_agent,
                        pten_code: this.pten_code,
                        pten_naam: this.pten_naam,
                        pten_email: this.pten_email,
                        pten_acco_city: this.pten_acco_city,
                        pten_acco_adres: this.pten_acco_adres,
                        pten_acco_postcode: this.pten_acco_postcode,
                        stat_codes: this.getSelected(this.statCodesSelected),
                        bron_codes: this.getSelected(this.bronCodesSelected),
                        ambassador_codes: this.getSelected(this.ambassadorCodesSelected),
                        gebr_codes: this.gebrCodesSelected,
                        land_codes: this.landCodesSelected,
                        prov_codes: this.provCodesSelected,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.loading = false;
                        this.items = res.data.searchPten;
                        this.agents = res.data.gebr_codeKeuzes;
                        this.results = true;
                        //this.$refs.stat2.updateSelector(this.statCodes);
                        if (res.data.statKeuzes.length > 0) {
                            this.statCodes = res.data.statKeuzes;
                        }
                    }
                });
            },
            setDuplicate(item) {
                this.$refs.setDuplicateLead.openDialog(item);
            },
            setToAssign(item) {
                this.$refs.setAssignLead.openDialog(item);
            },
            assignPtenLead(item) {
                this.$refs.assignLead.open(item, this.agents);
            },
            updateSelection(selectedField, codeField, newSelection) {
                //console.log(newSelection);
                this[selectedField] = newSelection;
                for (let i=0; i<this[codeField].length; i++) {
                    this[codeField][i].isSelected = false;
                    for (let j=0; j<this[selectedField].length; j++) {
                        if (this[codeField][i].Option === this[selectedField][j].Option) {
                            this[codeField][i].isSelected = true;
                        }
                    }
                }
            },
            updateData2(data) {
                switch (data.field) {
                    case "statCodesSelected":
                        this.updateSelection("statCodesSelected", "statCodes", data.value);
                        break;
                    case "bronCodesSelected":
                        this.updateSelection("bronCodesSelected", "bronCodes", data.value);
                        break;
                    case "ambassadorCodesSelected":
                        this.updateSelection("ambassadorCodesSelected", "ambassadorCodes", data.value);
                        break;
                    default:
                        alert("updateData2 - field not found");
                }
            },
            updateData(data) {
                switch (data.field) {
                    case "statCodesSelected":
                        this.updateSelection("statCodesSelected", "statCodes", data.value);
                        this.getPtens();
                        break;
                    case "bronCodesSelected":
                        this.updateSelection("bronCodesSelected", "bronCodes", data.value);
                        this.getPtens();
                        break;
                    case "ambassadorCodesSelected":
                        this.updateSelection("ambassadorCodesSelected", "ambassadorCodes", data.value);
                        this.getPtens();
                        break;
                    default:
                        alert("updateData - field not found");
                }
            },
            actionClick(action) {
                // console.log("tablePten", action);
                switch (action) {
                    case "refresh":
                        this.getPtens();
                        break;
                }
            },
            showParameters() {
                this.results = !this.results;
            },
            buildReport() {
                this.disableExport = true;
                this.$refs.showProgress.open();
                this.$axios.post("ares/json/ares/pten/excelExportPten.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "excelExportPten"
                    },
                    excelExportPten: {
                        items: this.items,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // bij afgerond overzicht stand bewaren, die wordt in component(en) opgevraagd
                        // this.items = res.data.excelExportPten;
                        window.open(res.data.excelExportPten.filename, '_blank');
                    }
                    this.$refs.showProgress.close();
                    this.disableExport = false;
                });
            },
            viewHistoryDialog(pten_code, text) {
                this.$refs.viewHistory.openDialog(pten_code, text);
            },
        }
    };
</script>

<style scoped>
    .align-text-top {
        vertical-align: top;
    }
</style>
